import { render, staticRenderFns } from "./ListCarriers.vue?vue&type=template&id=08d7c470&scoped=true"
import script from "./ListCarriers.vue?vue&type=script&lang=js"
export * from "./ListCarriers.vue?vue&type=script&lang=js"
import style0 from "./ListCarriers.vue?vue&type=style&index=0&id=08d7c470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7c470",
  null
  
)

export default component.exports